/*
 * Civia - custom design request form (round 95; phone layout round 104).
 *
 * The markup is server-rendered by snippets/civia-design-request.liquid on every
 * page. This file only opens and closes it.
 *
 * WHAT OPENS IT
 * Any link whose href contains #custom-design. The homepage "Custom Design"
 * section and the product page "Your Dream Design" section both link to
 * /pages/contact-us#custom-design, so the form opens in place over the page the
 * shopper is on. A modified click (new tab) is left to the browser, and so is
 * any page where the form is somehow missing - the link then simply goes to the
 * contact page, which has its own form.
 *
 * AFTER SUBMITTING
 * A Shopify contact form posts to /contact and redirects back to the page it
 * came from, where Liquid renders either the thank-you state or the errors. A
 * session flag set on submit reopens the dialog on that return trip so the
 * shopper sees the outcome - and only then, never on an ordinary page load.
 * The flag survives Shopify's bot-protection challenge page, which may sit
 * between the post and the return.
 *
 * ON PHONES (round 104)
 * The form was a centred card capped at 100vh - 24px. On a phone 100vh is the
 * screen height with the browser toolbars hidden, so while they show, the card
 * was taller than the visible area and centring pushed its top - and the close
 * button - above the screen, where scrolling inside the form could never reach
 * it. Focusing Name on open also raised the keyboard, which shrinks the visible
 * area further. Now:
 *  - up to 640px wide the form is a full-screen sheet sized to the visual
 *    viewport: the part of the screen between the toolbars and above the
 *    keyboard, followed as either changes;
 *  - the close button sits in a bar outside the scrolling panel, so it is on
 *    screen at every scroll position, on every screen size;
 *  - on a touch screen no field is focused on open; the shopper reads the form
 *    and taps the field they want.
 */
(function () {
  'use strict';

  if (window.__civiaDesignRequest) return;
  window.__civiaDesignRequest = true;

  var HASH = '#custom-design';
  var SENT_KEY = 'civia:design-request-sent';
  var STYLE_ID = 'civia-dr-style';

  var CSS =
    '.civia-dr{position:fixed;inset:0;margin:auto;height:fit-content;padding:0;border:0;' +
    'border-radius:12px;width:min(560px,calc(100% - 24px));max-width:none;' +
    /* dvh where supported - vh is the height with the toolbars hidden. */
    'max-height:calc(100vh - 24px);max-height:calc(100dvh - 24px);' +
    'background:#fff;color:#232323;box-shadow:0 24px 80px rgba(0,0,0,.25);overflow:hidden;z-index:2147483000}' +
    '.civia-dr[open]{display:flex;flex-direction:column}' +
    '.civia-dr.is-vv{max-height:calc(var(--civia-dr-vh) - 24px)}' +
    '.civia-dr::backdrop{background:rgba(20,16,12,.55)}' +
    /* The bar is outside the scrolling panel: the dialog itself never scrolls,
       so the close button stays put however far the form is scrolled. */
    '.civia-dr__bar{position:absolute;top:8px;right:8px;z-index:2}' +
    '.civia-dr__close{display:flex;align-items:center;justify-content:center;width:44px;height:44px;padding:0;' +
    'border:0;border-radius:50%;background:#fff;font-size:30px;line-height:1;color:#232323;cursor:pointer}' +
    '.civia-dr__close:focus-visible{outline:none;box-shadow:0 0 0 2px #232323}' +
    '.civia-dr__panel{position:relative;flex:1 1 auto;min-height:0;overflow-y:auto;overscroll-behavior:contain;' +
    '-webkit-overflow-scrolling:touch;padding:28px 24px 22px;box-sizing:border-box}' +
    '.civia-dr__title{margin:0 40px 6px 0;font-size:24px;line-height:1.25;font-weight:400;color:#232323;' +
    'text-transform:none;letter-spacing:0}' +
    '.civia-dr__lead{margin:0 0 18px;font-size:14px;line-height:1.55;color:#5a5a5a}' +
    '.civia-dr__grid{display:grid;grid-template-columns:1fr 1fr;gap:12px 14px}' +
    '.civia-dr__field{display:flex;flex-direction:column;gap:5px;min-width:0;margin:0}' +
    '.civia-dr__field--full{grid-column:1/-1}' +
    '.civia-dr__label{font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#5a5a5a}' +
    '.civia-dr__label em{font-style:normal;color:#b3261e}' +
    '.civia-dr__optional{text-transform:none;letter-spacing:0}' +
    '.civia-dr input,.civia-dr select,.civia-dr textarea{width:100%;box-sizing:border-box;margin:0;' +
    'font:inherit;font-size:16px;line-height:1.4;color:#232323;background:#fff;' +
    'border:1px solid #d8d2cb;border-radius:6px;padding:10px 12px;min-height:44px;box-shadow:none}' +
    '.civia-dr textarea{min-height:104px;resize:vertical}' +
    /* Focus is a ring drawn with box-shadow: the theme resets outlines on
       several elements, and a focus state the keyboard user cannot see is
       not a focus state. */
    '.civia-dr input:focus,.civia-dr select:focus,.civia-dr textarea:focus{outline:none;' +
    'border-color:#232323;box-shadow:0 0 0 2px rgba(35,35,35,.18)}' +
    '.civia-dr__submit{display:block;margin:16px 0 0;width:100%;min-height:48px;border:0;border-radius:6px;' +
    'background:#232323;color:#fff;font:inherit;font-size:14px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer}' +
    '.civia-dr__submit:hover{background:#000}' +
    '.civia-dr__submit[disabled]{opacity:.6;cursor:progress}' +
    '.civia-dr__fine{margin:10px 0 0;font-size:12px;color:#8a8a8a;text-align:center}' +
    '.civia-dr__error{margin:0 0 14px;padding:10px 12px;border-radius:6px;background:#fbeaea;color:#8c1d18;font-size:14px}' +
    '.civia-dr__error ul{margin:0;padding-left:18px}' +
    '.civia-dr__done{text-align:center;padding:14px 0 4px}' +
    '.civia-dr__done .civia-dr__title{margin-right:0}' +
    'html.civia-dr-open{overflow:hidden}' +
    /* Phones: a full-screen sheet with the close button in a bar across the top. */
    '@media (max-width:640px){' +
    '.civia-dr{inset:0 auto auto 0;width:100%;max-width:100%;height:100vh;height:100dvh;max-height:none;' +
    'margin:0;border-radius:0;box-shadow:none}' +
    '.civia-dr.is-vv{top:var(--civia-dr-top);height:var(--civia-dr-vh);max-height:none}' +
    '.civia-dr__bar{position:relative;top:auto;right:auto;flex:none;display:flex;justify-content:flex-end;' +
    'padding:calc(4px + env(safe-area-inset-top)) 6px 4px;background:#fff;' +
    'border-bottom:1px solid transparent;transition:border-color .2s}' +
    '.civia-dr.is-scrolled .civia-dr__bar{border-bottom-color:#ece7e1}' +
    '.civia-dr__panel{padding:4px 16px calc(20px + env(safe-area-inset-bottom))}' +
    '.civia-dr__grid{grid-template-columns:1fr}' +
    '.civia-dr__title{margin-right:0;font-size:21px}}';

  var vv = window.visualViewport;
  var fitFrame = 0;
  var fitHeight = 0;

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function dialog() {
    return document.getElementById('CiviaDesignRequest');
  }

  function touchScreen() {
    return !!(window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches);
  }

  /* Sizes the dialog to the visual viewport. dvh follows the toolbars but not
     the on-screen keyboard; this follows both. Skipped while the page is
     pinch-zoomed, when the visual viewport is a magnified piece of the page
     rather than the screen. */
  function fit() {
    fitFrame = 0;
    var d = dialog();
    if (!d || !vv) return;
    if (!d.open || Math.abs(vv.scale - 1) > 0.01) {
      d.classList.remove('is-vv');
      fitHeight = 0;
      return;
    }
    var shrank = fitHeight && vv.height < fitHeight;
    fitHeight = vv.height;
    d.style.setProperty('--civia-dr-vh', vv.height + 'px');
    d.style.setProperty('--civia-dr-top', vv.offsetTop + 'px');
    d.classList.add('is-vv');

    /* The keyboard just came up: keep the field being typed in on screen. */
    var field = document.activeElement;
    if (shrank && field && d.contains(field) && /^(INPUT|SELECT|TEXTAREA)$/.test(field.tagName)) {
      try {
        field.scrollIntoView({ block: 'nearest' });
      } catch (e) {}
    }
  }

  function queueFit() {
    if (!fitFrame) fitFrame = window.requestAnimationFrame(fit);
  }

  /* On a product page the piece is almost always the category being viewed, so
     it is preselected - one less field to touch. Anything unrecognised keeps
     the first option. */
  function guessPiece(select) {
    if (!select) return;
    var path = location.pathname;
    var title = (document.querySelector('.productView-title') || {}).textContent || '';
    var text = (path + ' ' + title).toLowerCase();
    var rules = [
      [/wedding.?band|eternity/, 'Wedding band'],
      [/earring|stud|hoop/, 'Earrings'],
      [/necklace|pendant/, 'Necklace or pendant'],
      [/bracelet/, 'Bracelet'],
      [/engagement|solitaire|ring/, 'Engagement ring']
    ];
    for (var i = 0; i < rules.length; i++) {
      if (rules[i][0].test(text)) {
        select.value = rules[i][1];
        return;
      }
    }
  }

  function open() {
    var d = dialog();
    if (!d) return false;

    injectStyle();

    /* The page a request came from, read at the moment it opens - on a product
       page the shape and metal switch in place, so the Liquid value can be a
       product the shopper has already moved away from. */
    var page = d.querySelector('[data-civia-dr-page]');
    if (page) page.value = location.pathname + (document.title ? ' | ' + document.title : '');
    if (!d.querySelector('[data-civia-dr-state]')) guessPiece(d.querySelector('[data-civia-dr-piece]'));

    var wasOpen = d.open;
    if (typeof d.showModal === 'function') {
      if (!d.open) d.showModal();
    } else {
      d.setAttribute('open', '');
    }
    document.documentElement.classList.add('civia-dr-open');

    if (!wasOpen) {
      var panel = d.querySelector('.civia-dr__panel');
      if (panel) panel.scrollTop = 0;
      d.classList.remove('is-scrolled');
    }

    fitHeight = 0;
    fit();
    if (vv) {
      vv.addEventListener('resize', queueFit);
      vv.addEventListener('scroll', queueFit);
    }

    /* A keyboard or mouse user can start typing their name straight away. On a
       touch screen that would raise the keyboard over half the form before the
       shopper has read it, so focus stays where showModal put it - the close
       button, first in the dialog. The thank-you button raises no keyboard and
       is focused everywhere. */
    var focus =
      d.querySelector('[data-civia-dr-state="sent"] [data-civia-dr-close]') ||
      (touchScreen() ? null : d.querySelector('input:not([type=hidden])'));
    if (focus) {
      try {
        focus.focus({ preventScroll: true });
      } catch (e) {
        focus.focus();
      }
    }
    return true;
  }

  function cleanUp() {
    document.documentElement.classList.remove('civia-dr-open');
    if (vv) {
      vv.removeEventListener('resize', queueFit);
      vv.removeEventListener('scroll', queueFit);
    }
    var d = dialog();
    if (d) d.classList.remove('is-vv');
    fitHeight = 0;
    if (location.hash === HASH && window.history && history.replaceState) {
      history.replaceState(history.state, '', location.pathname + location.search);
    }
  }

  function close() {
    var d = dialog();
    if (!d) return;
    if (typeof d.close === 'function') {
      if (d.open) d.close();
    } else {
      d.removeAttribute('open');
    }
    /* Not left to the dialog's close event alone - that event is not delivered
       in every environment, and a page stuck with overflow:hidden is broken. */
    cleanUp();
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    if (event.target.closest('[data-civia-dr-close]')) {
      event.preventDefault();
      close();
      return;
    }

    /* A click on the backdrop lands on the dialog element itself. */
    var d = dialog();
    if (d && event.target === d) {
      close();
      return;
    }

    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest('a[href]');
    if (!link || (link.getAttribute('href') || '').indexOf(HASH) === -1) return;
    if (!d) return;

    event.preventDefault();
    open();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id !== 'CiviaDesignRequestForm') return;

    try {
      sessionStorage.setItem(SENT_KEY, '1');
    } catch (e) {}

    var button = form.querySelector('[type=submit]');
    if (button) {
      /* Deferred so the button is still enabled while the browser builds the
         submission; disabling it synchronously can drop it from some forms. */
      setTimeout(function () {
        button.disabled = true;
        button.textContent = 'Sending…';
      }, 0);
    }
  });

  function boot() {
    var d = dialog();
    if (!d) return;

    d.addEventListener('close', cleanUp);

    /* A hairline under the phone bar once the form scrolls beneath it. */
    var panel = d.querySelector('.civia-dr__panel');
    if (panel) {
      panel.addEventListener(
        'scroll',
        function () {
          d.classList.toggle('is-scrolled', panel.scrollTop > 2);
        },
        { passive: true }
      );
    }

    var pending = false;
    try {
      pending = sessionStorage.getItem(SENT_KEY) === '1';
      sessionStorage.removeItem(SENT_KEY);
    } catch (e) {}

    if (pending && d.querySelector('[data-civia-dr-state]')) {
      open();
      return;
    }

    if (location.hash === HASH) open();
  }

  window.civiaDesignRequest = { open: open, close: close };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
